<template>
  <div id="app">
    <!-- 引用我们刚刚重构好的组件 -->
    <HotelMapDashboard />
  </div>
</template>


<script>
// 引入组件

import HotelMapDashboard from './components/dashboard/HotelMapDashboard.vue';

export default {
  name: 'App',
  components: {
    HotelMapDashboard
  }
}
/*
import ClusterTest from './components/ClusterTest.vue';

export default {
  name: 'App',
  components: {
    ClusterTest
  }
}*/

</script>

<style>
/* 全局样式重置，确保满屏显示 */
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  overflow: hidden; /* 防止浏览器出现原生滚动条 */
}

#app {
  height: 100%;
  width: 100%;
}
</style>